module.exports = __webpack_public_path__ + "img/Group 3298.55ba615c.png";